// extracted by mini-css-extract-plugin
export default {"root":"FoundingListenerBadge_root__85x6T","heart":"FoundingListenerBadge_heart__etcb4"};